import { render, staticRenderFns } from "./World-Heritage.vue?vue&type=template&id=dd5e9718&scoped=true"
import script from "./World-Heritage.vue?vue&type=script&lang=js"
export * from "./World-Heritage.vue?vue&type=script&lang=js"
import style0 from "./World-Heritage.vue?vue&type=style&index=0&id=dd5e9718&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5e9718",
  null
  
)

export default component.exports